import React from 'react';

import ImageIcon from '@atlaskit/icon/core/image';
import CommentIcon from '@atlaskit/icon/core/comment';
import FileIcon from '@atlaskit/icon/core/file';
import FolderClosedIcon from '@atlaskit/icon/core/folder-closed';
import PageIcon from '@atlaskit/icon/core/page';
import SmartLinkEmbedIcon from '@atlaskit/icon/core/smart-link-embed';
import TableIcon from '@atlaskit/icon/core/table';
import WhiteboardIcon from '@atlaskit/icon/core/whiteboard';
import QuotationMarkIcon from '@atlaskit/icon/core/quotation-mark';
import { Box } from '@atlaskit/primitives/compiled/box';

import type { ContentType } from '../utils/recently-updated-types.ts';

const iconProps = { label: '', color: 'currentColor' as const };

const iconByType: Record<ContentType, React.ReactNode> = {
	page: <PageIcon {...iconProps} />,
	blogpost: <QuotationMarkIcon {...iconProps} />,
	comment: <CommentIcon {...iconProps} />,
	attachment: <ImageIcon {...iconProps} />,
	whiteboard: <WhiteboardIcon {...iconProps} />,
	database: <TableIcon {...iconProps} />,
	embed: <SmartLinkEmbedIcon {...iconProps} />,
	userinfo: <FileIcon {...iconProps} />,
	folder: <FolderClosedIcon {...iconProps} />,
};

type ContentTypeIconProps = { contentType: ContentType };

export function ContentTypeIcon({ contentType }: ContentTypeIconProps): React.JSX.Element {
	return (
		<Box as="span" aria-hidden>
			{iconByType[contentType] ?? iconByType.page}
		</Box>
	);
}
